import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import type { MortgagePayloadInterface } from "../interfaces/mortgageDetailsInterface";

interface UserMortgageProfileStore {
	userMortgageProfile: MortgagePayloadInterface | null;
	setUserMortgageProfile: (profile: MortgagePayloadInterface) => void;
	clearUserProfile: () => void;
}

const useUserMortgageProfileStore = create<UserMortgageProfileStore>()(
	persist(
		(set) => ({
			userMortgageProfile: null,
			setUserMortgageProfile: (profile: MortgagePayloadInterface) =>
				set({ userMortgageProfile: profile }),
			clearUserProfile: () => set({ userMortgageProfile: null }),
		}),
		{
			name: "user-mortgage-profile-storage",
			storage: createJSONStorage(() => localStorage),
		},
	),
);

export { useUserMortgageProfileStore };
